var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span class=\"hidden-xs hidden-sm\" ng-class=\"{'hidden-md':$root.tiles, 'hidden-lg':$root.tiles}\">{{::$readableDatetimeCtrl.booking.datetime | datetime: 'dddd '}}\n</span>\n<span class=\"truncate-xs hidden-md hidden-lg\">{{::$readableDatetimeCtrl.booking.datetime | datetime: 'Do MMMM '}}</span>\n<span class=\"truncate-xs hidden-xs hidden-sm\">{{::$readableDatetimeCtrl.booking.datetime | datetime: 'Do MMM '}}</span>\n<span class=\"hidden-xs hidden-sm\" ng-class=\"{'hidden-md':$root.tiles, 'hidden-lg':$root.tiles}\">{{::$readableDatetimeCtrl.booking.datetime | datetime: 'YYYY'}}\n</span>";
var id1="javascripts/readable-datetime/readable_datetime.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/readable-datetime/readable_datetime.template.html
// module id = 1320
// module chunks = 0